import { type LegacyApiError, useApi } from '@omnipresentgroup/api';
import type { GetLegalEntityResponse } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useLegalEntity = ({
  id,
  enabled = true,
}: {
  id: string;
  enabled?: boolean;
}) => {
  const { GET } = useApi();

  return useQuery<GetLegalEntityResponse, LegacyApiError>({
    queryKey: [API_PATH, id],
    queryFn: () => GET<GetLegalEntityResponse>(`${API_BASE}/${API_PATH}/${id}`),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: Boolean(id) && enabled,
  });
};
